import $ from 'jquery';

const elements = {
    commentsConfig: '.c-comments-config',
};

export const updateComments = function (csrf) {
    const $commentsConfig = $(elements.commentsConfig);
    $commentsConfig.attr('data-comment-csrf-token', csrf);
}


// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/dynamic-csrf.js